import styled from "styled-components";

export const MessageContainer = styled.div`
  margin: 0.3125rem 2.5rem 0.3125rem 0.3125rem;
  padding: 0.375rem 0.4375rem 0.5rem 0.5625rem;
  line-height: 1.3;
  white-space: pre-wrap;
  word-break: break-word;
`;
